import type { CustomFieldCondition } from "@repo/app-types/entities/filterConditions";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import {
  longMenuMaxHeight,
  SimpleMenuPopover,
} from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";
import { CustomFieldConditionsMenu } from "./customFieldConditionsMenu.js";
import type { FilterParams } from "./filterParams.js";

export interface CustomFieldsFilterOptionProps {
  params: FilterParams;
  value: readonly CustomFieldCondition[];
  onChange: (newValue: readonly CustomFieldCondition[]) => void;
}

export const CustomFieldsFilterOption: FC<CustomFieldsFilterOptionProps> = ({
  params,
  value,
  onChange,
}) => {
  return (
    <SubmenuTrigger>
      <SimpleMenuItem>Custom fields</SimpleMenuItem>

      <SimpleMenuPopover maxHeight={longMenuMaxHeight}>
        <CustomFieldConditionsMenu
          playbookId={params.playbookId}
          onSelect={(condition) =>
            onChange([
              // Replace this custom field's previous condition. For example,
              // changing "after Oct 1" to "before Nov 1" must not apply both.
              // Conditions for other custom fields remain unchanged.
              ...value.filter(
                (existingCondition) =>
                  existingCondition.customFieldDefinitionId !==
                  condition.customFieldDefinitionId,
              ),
              condition,
            ])
          }
        />
      </SimpleMenuPopover>
    </SubmenuTrigger>
  );
};
